<template>
  <div id="manyidu" class="">
    <el-container>
      <div>
        <div class="bg-image">
          <div style="margin:80px 100px;width:100%;">
            <div style="margin-top:160px;">
              <h1>员工满意度</h1>
              <h1>敬业度调查服务</h1>
              <div class="english-intro">Investigation of Employee Engagement</div>
              <div class="intro-title">透过数据看本质，寻找驱动核心因素</div>
              <el-button style="margin-top:100px;" type="primary">立即联系：010-53323618</el-button>
            </div>          
          </div>
        </div>
        <div style="margin:140px 100px;">
          <div class="question">
            <el-row type="flex" align="middle">
              <el-col :span="8">
                <img src="../assets/images/Perfect-Match.png" alt="" style="width:100%">
              </el-col>
              <el-col :span="12" :offset="4">
                <div>
                  <h3>最大的问题—企业无从知晓</h3>
                  <div class="title-des">●内部流程—繁琐、效率低;</div>
                  <div class="title-des">●领导风格—认可程度、配合程度;</div>
                  <div class="title-des">●工作环境—外在环境（办公环境）、内在环境（企业文化）；</div>
                  <div class="title-des">●职业发展—培训体系、晋升路径；</div>
                  <div class="title-des">●工作职责—个人专业匹配度、兴趣匹配度;</div>
                  <div class="title-des">●薪资结构—薪酬外部竞争、内部公平、福利、绩效是否有效;</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="margin:160px 100px;">
          <div class="question" style="text-align:center;">
            <el-row>
              <el-col :span="6">
                <img src="../assets/images/bentu.png" alt="" style="width:60px;">
                <div style="margin-top:40px;">本土化常模库</div>
              </el-col>
              <el-col :span="6">
                <img src="../assets/images/zhenduan.png" alt="" style="width:60px;">
                <div style="margin-top:40px;">诊断后续建议</div>
              </el-col>
              <el-col :span="6">
                <img src="../assets/images/xianshang.png" alt="" style="width:60px;">
                <div style="margin-top:40px;">线上线下结合</div>
              </el-col>
              <el-col :span="6">
                <img src="../assets/images/baogao.png" alt="" style="width:60px;">
                <div style="margin-top:40px;">分析报告独立撰写</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="margin:160px 100px;padding:40px;box-shadow:0 3px 10px #bebebe">
          <h3>服务行业</h3>
          <div style="text-align:center;margin-top:40px">
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="tag">金融</div>
              </el-col>
              <el-col :span="6">
                <div  class="tag">地产</div>
              </el-col>
              <el-col :span="6">
                <div class="tag">医药</div>
              </el-col>
              <el-col :span="6">
                <div class="tag">传媒</div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top:30px;">
              <el-col :span="6">
                <div class="tag">制造业</div>
              </el-col>
              <el-col :span="6">
                <div  class="tag">高科技</div>
              </el-col>
              <el-col :span="6">
                <div class="tag">消费品</div>
              </el-col>
              <el-col :span="6">
                <div class="tag">能源化工</div>
              </el-col>
            </el-row>
          </div>
        </div>  
      </div>
    </el-container>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
export default {
  name:'manyidu',
  data(){
    return {
      
    }
  },
  methods:{
    
    
  },
  mounted(){
     
  }
}
</script>
<style scoped>
.home{
  background-color: #f4f4f4;
  width: 100%;
}
.bg-image{
  background-image: url('../assets/images/bg-image.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  overflow: hidden;
  width: 100%;
  height: 100vh;  
}
.english-intro{
  color:#9B9B9B;
}
.intro-title{
  color:#000000;
  margin-top: 40px;
}
.question{
  margin-top: 100px;
}
.title-des{
  margin-bottom: 10px;
  margin-left:20px;
}
.tag{
  padding: 20px 40px;
  background-color: #EFEFEF;
  color: #0bc8f4;
}
</style>
